const UNIT = ['%', 'px', 'em', 'vw', 'vh', 'rem']

export const checkUnit = (unit) => {
  const _unit = `${unit}`
  return UNIT.some(item => _unit.includes(item))
}

export const getTargetUnit = (unit) => {
  return checkUnit(unit) ? unit : unit / 100 + 'rem'
}

export const checkStatic = (path) => {
  if (!path) return true
  // H5 本地文件
  if (path.startsWith('blob:')) return true
  // APP 本地选择文件
  if (path.startsWith('file://')) return true
  // 项目本地文件
  if (path.startsWith('static')) return true
}
